import React, { useState, useEffect, Component } from "react";
import { connect } from "react-redux";
import dateUtil from "date-and-time";
import * as _ from "lodash";
import { setProjectDetails} from "../../../reducer/showAllReducer";
import axios from "axios";
import {authService} from "../../../auth";
import { Link, withRouter } from "react-router-dom";
import {getCDNUrl,convertUnicode} from "../../../commons/CommonFunctions";
import 'react-image-crop/dist/ReactCrop.css';
import { Doka, DokaModal, DokaOverlay, toURL } from '../../../commons/doka';
import uuid from "react-uuid";
import DonationComponent from "../../../Donation/DonationComponent";
import { setProfileBasicInfoDetails } from "../../../reducer/profile/ProfileReducer";
import Breadcumbs from "../../../Breadcumbs";

class Banner extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userData:authService.getUserDetailsFromLocalStorage(),
      projectVal: {
        startDate: "",
        endDate: "",
        title: "",
        status: "",
        paymentLink:null,
        coverImage:null,
        demolished:false,
        demolishedType:'',
        src: null,
        enabled: false,
        result: null,
        canChangeImage:false,
        crop: {
          aspectRatio: .5,
          rotation: -1.5707963268
        }
      },
      isShow:false,
      userId:'',
      donationBar: this.props.pageType === "HOME" ? this.props.donationBar : this.props.projectDetail?.donation,
      projectUserId: this.props.userId ? this.props.userId : authService.getUserDetailsFromLocalStorage().userId,
      organizationId: ""
    };
    this.onCropComplete = this.onCropComplete.bind(this);
    this.handleDokaCancel = this.handleDokaCancel.bind(this);
  }
  componentDidMount(){
    if ((this.props.projectDetail && this.props.projectDetail.isApproved != undefined) || this.props.isStudioPage) {
      this.getProjectDetails(this.props);
    } else{
      this.getProjectDetail();
    }
    if (this.props.projectDetail?.userId && this.props.projectDetail?.userType === "COMPANY" && this.props.profileBasicInfo) {
      this.props.profileBasicInfo({ userId: this.props.projectDetail?.userId });
    }
  }
  onSelectFile = e => {
    this.setState({enabled: true })
    this.setState({ src: e.target.files[0] })
  }

  onCropComplete(crop) {
    this.setState({
      enabled: false,
      result: crop.file
    });
    const formData = new FormData();
    if (this.state.result !== '')
      formData.append('coverImage', crop.file);
    formData.append('projectId', this.props.projectDetail.id);
    formData.append('type', this.state.projectVal.type);
    axios({
      method: 'post',
      url: process.env.REACT_APP_userServiceURL + '/backend/participation/update/cover/image',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      withCredentials: true
    }).then((response) => {
      let res = response.data;
      if (res.message === 'Success!') {
        this.setState({'isShow':false});
      }
    }).catch((err) => {

    });
  }

  handleToggle() {
    this.setState({
      enabled: !this.state.enabled
    });
  }


  handleDokaCancel() {
    this.setState({
      enabled: false,
      enabled1: false,
      srcProfile: '',
      src:'',
    });
    this.refs.CoverImageFileUploader.value = '';
    this.refs.ProfileImageFileUploader.value = ''
  }



  setProjectDetails(projectDetails) {
    this.props.setProjectDetails(projectDetails);
  };

  getProjectDetail() {
    let uid =
        authService.getUserDetailsFromLocalStorage() == null
            ? ""
            : authService.getUserDetailsFromLocalStorage().userId;
    axios({
      method: 'get',
      url: process.env.REACT_APP_userServiceURL + "/participants/" +
          "find-project-description-details-by-userId-and-slug/" + uid+"/"+this.props.match.params.projectId ,
      headers: {'Content-Type': 'application/json'},
      withCredentials: true
    }).then(response => {
      if (response && response.data && response.data.body && response.data.message === 'Success!') {
        this.setProjectDetails(response.data.body);
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  componentWillReceiveProps(props) {
    if (props.projectDetail && props.projectDetail.isApproved != undefined) {
      this.getProjectDetails(props);
    }
    if(!_.isEmpty(props.profileBasicInfoData) && props.profileBasicInfoData?.superAdminId === authService.getUserDetailsFromLocalStorage().userId) {
      this.setState({
        organizationId: props.projectDetail?.userId
      })
    } 
  }

  getProjectDetails = (props) => {
    let project = props.projectDetail;
    let startDate = "";
    let endDate = "NA";
    let title = "";
    let type = ""
    let coverImage=null;
    let resizedImages = null;
    let demolished = project.demolished;
    let paymentLink = props.projectDetail && props.projectDetail.project && props.projectDetail.project.paymentLink;
    let demolishedType = project.demolishedType;
    let userId = "";
    let canChangeImage
    let stageValue = "Completed";
    if (props.projectDetail && project.isApproved != undefined) {
      let proj = props.projectDetail.project;
      title =
          proj.jobTitle ||
          proj.sessionTitle ||
          proj.assignmentTitle ||
          proj.jobTitle ||
          proj.title;
      let stage = project.stage;
      userId = project.userId;
      type = project.participationDetails && project.participationDetails.secondaryEntityType;
       canChangeImage = project.canChangeImage;
      coverImage = proj.coverImage;
      resizedImages = project.project && project.project.resizedImages;
      startDate = dateUtil.format(new Date(project.startDate), "DD MMM YYYY");
      if(project.endDate >0){
        endDate = dateUtil.format(new Date(project.endDate), "DD MMM YYYY");
      }

      stageValue = stage.charAt(0).toUpperCase() + stage.slice(1);
      /*stageValue = "Running";

      if (new Date() < new Date(project.startDate)) {
        stageValue = "UpComing";
      }else if (new Date(project.startDate) === new Date(project.endDate)) {
        stageValue = "Running";
      }else if (new Date() > new Date(project.endDate)) {
        stageValue = "Completed";
      }*/
    }

    this.setState({
      projectVal: {
        startDate,
        endDate,
        title,
        status: stageValue,
        coverImage,
        resizedImages,
        paymentLink,
        userId,
        type,
        demolished,
        demolishedType,
        canChangeImage,
      },'userId':userId
    });
    // setProject({
    //   startDate,
    //   endDate,
    //   title,
    //   status: stageValue,
    // });

    return {
      startDate,
      endDate,
      title,
      status: stageValue,
    };
  };


  handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData();
    if (this.state.projectVal.bannerImage !== '')
      formData.append('coverImage', this.state.projectVal.bannerImage);
    formData.append('projectId', this.props.projectDetail.id);
    formData.append('type', this.state.projectVal.type);
    axios({
      method: 'post',
      url: process.env.REACT_APP_userServiceURL + '/backend/participation/update/cover/image',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      withCredentials: true
    }).then((response) => {
      let res = response.data;
      if (res.message === 'Success!') {
        this.setState({'isShow':false});
      }
    }).catch((err) => {

    });

  };


  getOptimizedCoverImage(projectVal) {
    if (window.innerWidth > 1000 && projectVal.resizedImages && projectVal.resizedImages['1000x1000'] != null) {
        return projectVal.resizedImages['1000x1000'];
    } else if (window.innerWidth > 600 && window.innerWidth <= 1000 && projectVal.resizedImages && projectVal.resizedImages['800x800'] != null) {
        return projectVal.resizedImages['800x800'];
    } else if (window.innerWidth > 320 && window.innerWidth <= 600 && projectVal.resizedImages && projectVal.resizedImages['600x600'] != null) {
        return projectVal.resizedImages['600x600'];
    } else if (projectVal.resizedImages && projectVal.resizedImages['compressed'] != null) {
        return projectVal.resizedImages['compressed'];
    } else {
        return projectVal.coverImage;
    }
  }


  //getProjectDetails();
  render() {
    const { src } = this.state

    return (
        <div className="prdbannerwrap">
          <div className="breadcumbwtBack">
            <div><button class="goback btn globalback" onClick={() => this.props.history.goBack()}><span>Back</span></button></div>
            <Breadcumbs crumbs={[{ "name": "Projects", "path": `/profile-project/${this.state.userData?.customUrl}` }, { "name": `${this.props.projectDetail?.project?.title}`, "path": `/project/feeds/${this.props.projectDetail?.project?.slug}` }, ...(this.props.isStudioPage ? [{ "name": `Studio`, "path": null }] : []) ]} />
          </div>
          <div className="profilebann">
            <input type="file" className="file" name="myImage"
                   accept=".jpg,.jpeg,.png"
                   id="imageUploader"
                   onChange={this.onSelectFile} ref="CoverImageFileUploader" />

            {this.state.projectVal && this.state.projectVal.canChangeImage && this.state.projectVal.demolished === false && !this.props.isStudioPage &&
            <button type="button" className="browse btn btn-primary">Change Image
            </button>}
            {this.state.enabled ? <DokaOverlay
                style={{ width: '898px', height: '218px' }}
                id="preview"
                allowAutoDestroy="true"
                src={src}
                size={{width: 898, height: 218}}
                cropAllowResizeRect={false}
                //markup={[['rect',{x:0,y:0,backgroundColor:'red',width:'100px', height:'100px'}]]}
                onConfirm={this.onCropComplete}
                onCancel={this.handleDokaCancel}/> : <>
              {this.state.result ? (
                  <a data-fancybox={uuid()} href={toURL(this.state.result)}>
                      <img alt="Crop" style={{ maxWidth: '100%' }} src={toURL(this.state.result)} id="preview" /></a>
              ) : <a data-fancybox={uuid()} href={this.state.projectVal && this.state.projectVal.coverImage && !_.isNull(this.state.projectVal.coverImage) ? getCDNUrl(this.state.projectVal.coverImage) : (!_.isUndefined(this.state.projectVal.coverImage)) ? 'https://cdn.dscovr.com/images/project-default.jpg' : null}>
                    <img 
                      src={this.state.projectVal && this.state.projectVal.coverImage && !_.isNull(this.state.projectVal.coverImage) ? this.state.projectVal.coverImage/*getCDNUrl(this.getOptimizedCoverImage(this.state.projectVal))*/ : (!_.isUndefined(this.state.projectVal.coverImage)) ? 'https://cdn.dscovr.com/images/project-default.jpg' : null} 
                      id="preview" /></a>}
            </>}
            {this.state.error && this.state.error !=='' &&
            <div className="login-feedback-error" style={{display: "block"}}>
              {this.state.error}
            </div>}
            { this.state.isShow &&
            <button type={"button"} onClick={this.handleSubmit}
                     className="btn dgbtn-primary">Update</button>
            }
            {this.state.projectVal && this.state.projectVal.type && this.state.projectVal.type.toLowerCase() === 'fundraise' && this.state.projectVal.paymentLink &&
                this.props.projectDetail && this.props.projectDetail.demolished === false && this.props.projectDetail.stage && this.props.projectDetail.stage.toLowerCase() !== 'completed' &&
                this.props.projectDetail.userId && this.props.projectDetail.creatorUserId !== authService.getUserDetailsFromLocalStorage().userId &&
                <a href={this.state.projectVal.paymentLink} target={'_blank'} className={'btn payNow'}>Pay Now</a>
            }            
          </div>


          {/*<img  src={this.state.projectVal && !_.isNull(this.state.projectVal.coverImage)?this.state.projectVal.coverImage:!_.isUndefined(this.state.projectVal.coverImage) ? 'https://cdn.dscovr.com/images/project-details-banner.png' : null} alt="" />*/}
          <div className="prdbanndesc">
            <div className="d-flex align-items-center justify-content-space-between">
              <h1 className="projttlh1">
                {/* {getProjectDetails().title}    */}
                {this.props.isStudioPage ? <Link to={{pathname: `/project/feeds/${this.props.projectDetail.slug}`, state: {userId: this.state.projectUserId}}}>{convertUnicode(this.state.projectVal.title)}</Link> : convertUnicode(this.state.projectVal.title)}
                {this.props.projectDetail && this.props.projectDetail.privateProject &&
                  <i className="iSheild_Lock" />
                }
              </h1>
             {/* {<a href="javascript:void(0)" className="viewAllAct btn-primary btn" style={{background: "#f3f9f1", cursor: "default"}}>{"Project"}</a>} */}
            </div>
            {this.state.projectVal.demolished === false &&
            <div className="banndatewrap">
              <div>
                <span>Start Date</span> {this.state.projectVal.startDate}
                {/* {getProjectDetails().startDate} */}
              </div>
              <div>
                <span>End Date</span> {this.state.projectVal.endDate}
                {/* {getProjectDetails().endDate} */}
              </div>
              {this.state.projectVal.demolished === false &&
              <div className="pdbannstatus">{this.state.projectVal.status}</div>
              }
             
            </div>
            }
            {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === true &&
              <div className="banndatewrap">
                <div>
                  <span>Project has been cancelled on </span> {dateUtil.format(new Date(this.props.projectDetail.demolishedDate), "DD MMM YYYY")}
                </div>
                <div className="pdbannstatus cancel">{this.state.projectVal.status}</div>
              </div>
            }
            {this.props?.projectDetail?.id && this.props?.projectDetail?.stage !== "DELETED" && this.props?.projectDetail?.stage !== "CANCELLED" && <DonationComponent entityDetails={this.props.projectDetail} entityId={this.props.projectDetail.id} entitySlug={this.props.projectDetail?.slug} superAdminId={this.props.projectDetail?.participationDetails?.partyType === "CIRCLE" && this.props.projectDetail?.params?.superAdminId ? this.props.projectDetail?.params?.superAdminId : this.props.projectDetail?.participationDetails?.participatingUserId} creatorUserId={this.props.projectDetail?.participationDetails?.creatorUserId} donationBar={this.state.donationBar} entityType={"PROJECT"} changeTab={this.props.changeTab} getEntityDonationConfig={this.props.getEntityDonationConfig} needDonationConfig={this.props.needDonationConfig} getDonationConfig={this.props.getDonationConfig} pageType={this.props.pageType} userId={this.state.organizationId} projectUserId={this.props.projectDetail?.project?.userId} />}
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    project: state.showAllReducer.projectDetails,
    profileBasicInfoData: state.ProfileReducer.profileBasicInfo
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setProjectDetails: (projectDetails) => dispatch(setProjectDetails(projectDetails)),
    profileBasicInfo: (state) => dispatch(setProfileBasicInfoDetails(state))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Banner));
